export default __webpack_public_path__ + "651d66903f6970632efa50f1da52fa52.png";